import useRequest from "kb-gql";

export const seoQuery = `
    title
    date
    modified
    thumbnailData {
        buzzwords
        description
        featuredImage {
        mediaItemUrl
            altText
            mediaDetails {
                width
                height
            }
        }
    }
`;

const globalSeoQuery = `
	seo {
		schema {
			siteName
			wordpressSiteName
			siteUrl
			companyName
			companyLogo {
				mediaItemUrl
			}
			logo {
				mediaItemUrl
			}
		}
	}
`;

export const useGlobalSeo = () => {
    return useRequest(globalSeoQuery, "_global_seo");
};

// Site-wide defaults from WP Admin > Settings > General.
// `description` is the WordPress tagline, used as the fallback
// search/social preview text when a page has no description of its own.
const generalSettingsQuery = `
    generalSettings {
        title
        description
    }
`;

export const useGeneralSettings = () => {
    return useRequest(generalSettingsQuery, "generalSettings");
};
